import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EVENT_BUS } from '@shared/domain/tokens/event-bus.token';
import { ServiceStateService } from '@features/service/application/services/service-state.service';
import { ServiceWorkerChangedEvent } from '@platform/event-bus/domain/events/service-worker-changed.event';
import { ServiceRedirectPort } from '@features/service/domain/port/service-redirect.port';


@Injectable({ providedIn: 'root' })
export class ServiceChangeWorkerSubscriber {
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);
  private readonly serviceStateService = inject(ServiceStateService);
  private readonly redirect = inject(ServiceRedirectPort);

  constructor() {
    this.eventBus.ofType(ServiceWorkerChangedEvent).pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => {
      this.serviceStateService.clearWorker();
      this.redirect.goToServiceConfiguration();
    });
  }
}
